class CardProductPilgrimSwatches {
  static init() {
    document.addEventListener('click', CardProductPilgrimSwatches.onClick);
  }

  static onClick(event) {
    const swatch = event.target.closest('.card-product-pilgrim__swatch');
    if (!swatch) return;

    event.preventDefault();

    const card = swatch.closest('.card-wrapper--pilgrim');
    if (!card) return;

    const variantId = swatch.dataset.variantId;
    if (!variantId) return;

    card.querySelectorAll('.card-product-pilgrim__swatch').forEach((item) => {
      item.classList.remove('card-product-pilgrim__swatch--active');
      item.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('card-product-pilgrim__swatch--active');
    swatch.setAttribute('aria-pressed', 'true');

    const addToCart = card.querySelector('add-to-cart.card-product-pilgrim__button');
    if (addToCart) {
      addToCart.dataset.variantId = variantId;

      if (swatch.dataset.available === 'false') {
        addToCart.setAttribute('disabled', 'true');
        addToCart.classList.add('card-product-pilgrim__button--soldout');
      } else {
        addToCart.removeAttribute('disabled');
        addToCart.classList.remove('card-product-pilgrim__button--soldout');
      }
    }

    const image = card.querySelector('.card-product-pilgrim__image--primary');
    if (image && swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) {
        image.srcset = swatch.dataset.imageSrcset;
      }
      // Keep the selected variant image visible; don't let card hover swap to secondary.
      card.classList.add('card-wrapper--pilgrim-swatch-selected');
    }

    const priceEl = card.querySelector('.card-product-pilgrim__price');
    if (priceEl && swatch.dataset.price) {
      priceEl.textContent = swatch.dataset.price;
    }

    const compareEl = card.querySelector('.card-product-pilgrim__compare');
    const discountEl = card.querySelector('.card-product-pilgrim__discount');
    const priceRow = card.querySelector('.card-product-pilgrim__price-row .tw-flex');

    if (swatch.dataset.comparePrice) {
      if (compareEl) {
        compareEl.textContent = swatch.dataset.comparePrice;
        compareEl.hidden = false;
      }
      if (discountEl && swatch.dataset.discount) {
        discountEl.textContent = swatch.dataset.discount;
        discountEl.hidden = false;
      } else if (!discountEl && priceRow && swatch.dataset.discount) {
        const badge = document.createElement('span');
        badge.className =
          'card-product-pilgrim__discount tw-inline-flex tw-h-6 tw-items-center tw-rounded-[4px] tw-bg-pilgrim-magenta-700 tw-px-[10px] tw-py-[3px] tw-font-sans tw-text-[14px] tw-font-medium tw-uppercase tw-leading-none tw-text-pilgrim-neutral-0';
        badge.textContent = swatch.dataset.discount;
        priceRow.appendChild(badge);
      }
    } else {
      if (compareEl) compareEl.hidden = true;
      if (discountEl) discountEl.hidden = true;
    }
  }
}

CardProductPilgrimSwatches.init();
